import React from "react";

const AddAddress = ({ handleChange, handleSubmit }) => {
  return (
    <>
      <h1 className="text-3xl mb-2 mt-4 text-center font-extrabold dark:text-white">
        Add Address
      </h1>
      <div className="lg:my-4 md:my-4 lg:w-[80%] m-auto ">
        <div className="md:grid md:grid-cols-2 md:gap-6">
          <div className="mt-5 md:mt-0 md:col-span-2">
            <form onSubmit={handleSubmit}>
              <div className="shadow-lg border overflow-hidden sm:rounded-md dark:border-none">
                <div className="px-4 py-5 bg-white sm:p-6 dark:bg-[#1d1e2b] ">
                  <div className="grid grid-cols-6 gap-6">
                    <div className="col-span-6">
                      <label
                        htmlFor="street-address"
                        className="block text-sm font-medium text-gray-700 dark:text-white"
                      >
                        Street address
                      </label>
                      <input
                        type="text"
                        name="street"
                        id="street-address"
                        autoComplete="street-address"
                        className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md ouline outline-indigo-600 px-2 py-2 text-xl border border-grey-200 dark:bg-[#2d2f40] dark:border-gray-800 dark:text-white"
                        required
                        onChange={handleChange}
                      />
                    </div>

                    <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                      <label
                        htmlFor="city"
                        className="block text-sm font-medium text-gray-700 dark:text-white"
                      >
                        City
                      </label>
                      <input
                        type="text"
                        name="city"
                        id="city"
                        autoComplete="address-level2"
                        className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md ouline outline-indigo-600 px-2 py-2 text-xl border border-grey-200 dark:bg-[#2d2f40] dark:border-gray-800 dark:text-white"
                        required
                        onChange={handleChange}
                      />
                    </div>

                    <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                      <label
                        htmlFor="region"
                        className="block text-sm font-medium text-gray-700 dark:text-white"
                      >
                        State / Province
                      </label>
                      <input
                        type="text"
                        name="state"
                        id="region"
                        autoComplete="address-level1"
                        className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md ouline outline-indigo-600 px-2 py-2 text-xl border border-grey-200 dark:bg-[#2d2f40] dark:border-gray-800 dark:text-white"
                        required
                        onChange={handleChange}
                      />
                    </div>

                    <div className="col-span-6 sm:col-span-3 lg:col-span-2">
                      <label
                        htmlFor="postal-code"
                        className="block text-sm font-medium text-gray-700 dark:text-white"
                      >
                        ZIP / Postal code
                      </label>
                      <input
                        type="text"
                        name="pincode"
                        id="postal-code"
                        autoComplete="postal-code"
                        className="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md ouline outline-indigo-600 px-2 py-2 text-xl border border-grey-200 dark:bg-[#2d2f40] dark:border-gray-800 dark:text-white"
                        required
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="px-4 py-3 bg-gray-50 dark:bg-[#1f202e] text-right sm:px-6">
                  <button
                    type="submit"
                    className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                  >
                    Add
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddAddress;
